import React, {Component} from 'react';
import {Route, Redirect, Switch} from 'react-router-dom';
import {withRouter} from 'react-router';
import {hot} from 'react-hot-loader';

import api, {tryGetPersistedAuth} from './store/services/api';
import {onLoginSuccess} from './store/identity';
import MainRoutes from './features/layout/MainRoutes';
import PrivateRoute from './features/security/PrivateRoute';
import AccountRoutes from './features/account/Routes';
import I18nContext, {getBrowserLanguage} from './features/i18n/Context';
import LoadingContainer from './features/layout/LoadingContainer';

class App extends Component {
  state = {
    locale: getBrowserLanguage(),
    authCheck: false,
  };

  async componentDidMount() {
    try {
      const user = tryGetPersistedAuth();
      if (user) {
        await api.get('users/me');
        onLoginSuccess({payload: user});
      }
    } catch (error) {
    } finally {
      this.setState({authCheck: true});
    }
  }

  render() {
    if (!this.state.authCheck) {
      return (
        <LoadingContainer
          loading
          hideContentWhenLoading
          transparent
          message="Authenticating..."
        />
      );
    }
    return (
      <I18nContext.Provider value={this.state.locale}>
        <Switch>
          <Route path="/account" component={AccountRoutes} />
          <PrivateRoute path="/" component={MainRoutes} />
          <Redirect to="/" />
        </Switch>
      </I18nContext.Provider>
    );
  }
}

export default hot(module)(withRouter(App));
